<div class="row mt-4">
  <div class="col-sm-12 overflow-auto">
    <div class="timeline d-flex flex-nowrap gray-200">
      <button type="button"
              id="period_{{[i]}}"
              class="empty"
              [style.width.%]="period.sizePercentage"
              *ngFor="let period of periodList; let i = index"
              [ngClass]="{'filled' : period.hasEffectivity ,'disable-on-fieldset' : !period.hasEffectivity , 'active' : period.active}"
              (click)="onPeriodClick(i)"
              >
        <span *ngIf="!period.hasEffectivity" class="icon-add"></span>
        <span *ngIf="period.active && period.sizePercentage >= 10 && period.hasEffectivity" class="icon-close"></span>
        <span class="date"*ngIf="period.hasEffectivity && period.sizePercentage >= 10">{{period.startDate | date : 'yyyy'}} - {{period.endDate | date  : 'yyyy'}}</span>
      </button>
    </div>
  </div>
</div>
